import { Box, Typography } from '@mui/material';
import React from 'react';

export const NoDataTableContent = () => (
  <Box p={10} justifyContent="center" alignItems="center" width="100%" margin="auto">
    <Typography variant="h5">No Data</Typography>
  </Box>
);
